import { requestApi } from 'api/api'
import {
  ReportSchedule,
  ReportSchedulesResponse,
  ReportScheduleTimeZone,
} from 'types/walletTransactionsExport'

export const REPORTING_PATH = '/ledger/v1/report-schedules'

export const getReportSchedules = (): Promise<ReportSchedulesResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `${REPORTING_PATH}`,
    params: {
      type: 'TRANSACTION',
      allWallets: true
    },
    method: 'GET',
  })
}

export const getReportScheduleTimezones = (): Promise<ReportScheduleTimeZone[]> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `${REPORTING_PATH}/timezones`,
    method: 'GET',
  })
}

export const deleteReportSchedule = (id: number): Promise<unknown> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `${REPORTING_PATH}/${id}`,
    method: 'DELETE',
  })
}

export const postReportSchedule = (data: ReportSchedule): Promise<ReportSchedule> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: REPORTING_PATH,
    method: 'POST',
    data,
  })
}

export const putReportSchedule = (data: ReportSchedule): Promise<ReportSchedule> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `${REPORTING_PATH}/${data?.id}`,
    method: 'PUT',
    data,
  })
}
